import {LocalOffer} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import CouponCodes from './CouponCodes';

export const couponCodes: FeatureObject = {
  type: 'settings',
  title: 'Coupon Codes',
  description: 'Manage coupon codes for user promotions and access control',
  path: '/settings/coupon-codes',
  component: (user) => <CouponCodes user={user} />,
  IconComponent: LocalOffer,
  status: FeatureStatus.BETA,
  tags: [],
  permission: 'owner',
};
